import React from 'react';
import BaseTextArea, { BaseTextAreaProps } from './BaseTextArea';

/**
 * Multi-line text field based on https://seek-oss.github.io/braid-design-system/components/Textarea
 *
 * Provides support for adding a label above the field and additional content (a "message") below
 * the field. Also provides an `appearance` prop that can be used to indicate whether the field
 * should be "bordered", or separated from the bounds of the container with some margin and a
 * border, or "stretched", or flush with the bounds of the container.
 */
const Textarea: React.FCWithChildren<Omit<BaseTextAreaProps, 'multiline'>> = (
  React.forwardRef((props, ref) => <BaseTextArea {...props} multiline ref={ref} />)
);

export default Textarea;
